import { PropsWithChildren } from 'react';

export type HeadingProps = {
  level?: string | number;
  className?: string;
  id?: string;
  style?: any;
};

const Heading = ({
  children,
  id,
  level = 1,
  className,
  style,
}: PropsWithChildren<HeadingProps>) => {
  if (!children) return null;
  const HeadingTag: any = `h${level}`;
  return (
    <HeadingTag id={id} className={className} style={style}>
      {children}
    </HeadingTag>
  );
};

export default Heading;
